import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

/**
 * Reusable phone input with flag picker, validation styling, and inline error.
 *
 * Props:
 *   name       – field name (passed to the underlying <input>)
 *   value      – controlled value (digits only, no leading +)
 *   onChange   – (value: string) => void
 *   onBlur     – () => void
 *   touched    – boolean
 *   error      – string | undefined
 *   country    – default country code, e.g. "gb" (default: "gb")
 *   ...rest    – forwarded to PhoneInput
 */
const FormPhoneInput = ({
  name,
  value,
  onChange,
  onBlur,
  touched,
  error,
  country = "gb",
  ...rest
}) => {
  const isInvalid = !!(touched && error);

  return (
    <>
      <PhoneInput
        country={country}
        enableSearch
        countryCodeEditable={false}
        containerClass="w-100"
        inputProps={{ name, "aria-invalid": isInvalid }}
        inputClass={isInvalid ? "form-control is-invalid" : "form-control"}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        {...rest}
      />
      {isInvalid && <div className="invalid-feedback d-block">{error}</div>}
    </>
  );
};

export default FormPhoneInput;
